import { cn } from '../../../../lib/cn';

/** 1X2 base pick: a big crest/flag up top, team or "Draw" title anchored at the bottom. */
export function BaseButton({
  active,
  badge,
  title,
  onClick
}: {
  active: boolean;
  badge: React.ReactNode;
  title: string;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'tap flex min-h-[88px] flex-1 flex-col items-center justify-between rounded-[15px] px-1.5 pb-2.5 pt-3 text-center transition-[transform,background-color,border-color,color,box-shadow] duration-150 ease-ios-out active:scale-[0.97]',
        active ? 'bg-night text-white shadow-[0_10px_22px_-12px_rgba(0,0,0,0.5)]' : 'border-[1.5px] border-black/10 bg-white text-ink'
      )}
      style={active ? { border: '1.5px solid #15151B' } : undefined}
    >
      <span className="flex min-h-[44px] flex-1 items-center justify-center">{badge}</span>
      <span className={cn('max-w-full truncate px-0.5 text-[12.5px] font-extrabold leading-tight tracking-[-0.01em]', active ? 'text-white' : 'text-ink')}>
        {title}
      </span>
    </button>
  );
}
